import { Fragment, useEffect, useState } from "react";
import { Dialog, Tab, Transition } from "@headlessui/react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { useTimeoutFn } from "react-use";
import CarsSearchForm from "./(car-search-form)/CarsSearchForm";

import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useData } from "data/data-provider";
import moment from "moment";

const HeroSearchForm2Mobile = () => {
  const {
    startDate,
    startHours,
    startMinutes,
    startPeriod,
    endDate,
    endHours,
    endMinutes,
    loadingAvailableFleet,
    endPeriod,
    setEndDate,
    setEndHours,
    setEndMinutes,
    setEndPeriod,
    setStartDate,
    setStartHours,
    setStartMinutes,
    setStartPeriod,
    ourCompany,
    pickupLocation,
    dropOffLocation,
    callAvailableFleetAPI,
  } = useData();

  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  // FOR RESET ALL DATA WHEN CLICK CLEAR BUTTON
  const [showDialog, setShowDialog] = useState(false);

  const hoursOptions = Array.from({ length: 12 }, (_, i) =>
    String(i + 1).padStart(2, "0")
  );
  const minutesOptions = Array.from({ length: 60 }, (_, i) =>
    String(i).padStart(2, "0")
  );
  const periodOptions = ["AM", "PM"];

  let [, , resetIsShowingDialog] = useTimeoutFn(() => setShowDialog(true), 1);
  //

  useEffect(() => {
    validateStartDateTime();
  }, [startDate, endDate]);
  useEffect(() => {
    validateEndTime();
  }, [startDate]);

  const validateStartDateTime = () => {
    if (!startDate || !endDate) {
      toast.error("No start date or end date");
      return;
    }
    if (startDate < new Date()) {
      toast.error(
        "Trip start date and time cannot be in the past. Please choose a date and time after the current time."
      );
    }
    return startDate < new Date();
  };
  const validateEndTime = () => {
    if (
      startDate &&
      endDate &&
      startDate.toDateString() === endDate.toDateString()
    ) {
      const startTime = new Date();
      startTime.setHours(
        parseInt(startHours) + (startPeriod === "PM" ? 12 : 0),
        parseInt(startMinutes)
      );

      const endTime = new Date();
      endTime.setHours(
        parseInt(endHours) + (endPeriod === "PM" ? 12 : 0),
        parseInt(endMinutes)
      );

      if (endTime < startTime) {
        toast.error("Trip end date time cannot be before trip start date time");
        setEndHours(startHours);
        setEndMinutes(startMinutes);
        setEndPeriod(startPeriod);
      }
    }
  };

  function closeModal() {
    setShowModal(false);
  }

  function openModal() {
    setShowModal(true);
  }

  const renderButtonOpenModal = () => {
    return (
      <button
        onClick={openModal}
        className="relative flex items-center w-full border border-neutral-200 dark:border-neutral-6000 px-4 py-2 pr-11 rounded-full shadow-lg bg-white bg-opacity-80"
      >
        <MagnifyingGlassIcon className="flex-shrink-0 w-5 h-5" />

        <div className="ml-3 flex-1 text-left overflow-hidden">
          <span className="block font-medium text-sm">Where to?</span>
          <div className="block mt-0.5 text-xs font-light text-neutral-500 dark:text-neutral-400 ">
            <span className="line-clamp-1">Anywhere • Any week</span>
          </div>
        </div>

        <span className="absolute right-2 top-1/2 transform -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-full border border-neutral-200 dark:border-neutral-6000 dark:text-neutral-300">
          <svg
            viewBox="0 0 16 16"
            aria-hidden="true"
            role="presentation"
            focusable="false"
            className="block w-4 h-4"
            fill="currentColor"
          >
            <path d="M5 8c1.306 0 2.418.835 2.83 2H14v2H7.829A3.001 3.001 0 1 1 5 8zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm6-8a3 3 0 1 1-2.829 4H2V4h6.17A3.001 3.001 0 0 1 11 2zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"></path>
          </svg>
        </span>
      </button>
    );
  };

  const isWithinOperationalHours = (
    startHours: string,
    startMinutes: string,
    startPeriod: string,
    endHours: string,
    endMinutes: string,
    endPeriod: string,
    ourCompany: any
  ): boolean => {
    if (ourCompany?.always_operational) {
      return true;
    }

    const operationalStart = new Date();
    const operationalEnd = new Date();
    const selectedStart = new Date();
    const selectedEnd = new Date();

    // Ensure `operational_start_time` and `operational_end_time` are valid strings
    const operationalStartTime = ourCompany?.operational_start_time || "00:00";
    const operationalEndTime = ourCompany?.operational_end_time || "23:59";

    const [opStartHour, opStartMinute] = operationalStartTime
      ?.split(":")
      .map(Number);
    const [opEndHour, opEndMinute] = operationalEndTime?.split(":").map(Number);

    // Set operational hours
    operationalStart.setHours(opStartHour, opStartMinute, 0, 0);
    operationalEnd.setHours(opEndHour, opEndMinute, 0, 0);

    // Convert start and end times to 24-hour format
    const startHour24 =
      parseInt(startHours) +
      (startPeriod === "PM" && startHours !== "12" ? 12 : 0);
    const endHour24 =
      parseInt(endHours) + (endPeriod === "PM" && endHours !== "12" ? 12 : 0);

    // Set selected start and end times
    selectedStart.setHours(startHour24, parseInt(startMinutes), 0, 0);
    selectedEnd.setHours(endHour24, parseInt(endMinutes), 0, 0);

    // Check if the selected times are within operational hours
    const isStartWithinHours =
      selectedStart >= operationalStart && selectedStart <= operationalEnd;
    const isEndWithinHours =
      selectedEnd >= operationalStart && selectedEnd <= operationalEnd;

    return isStartWithinHours && isEndWithinHours;
  };

  console.log(
    !isWithinOperationalHours(
      startHours,
      startMinutes,
      startPeriod,
      endHours,
      endMinutes,
      endPeriod,
      ourCompany
    )
  );
  return (
    <div className="HeroSearchForm2Mobile">
      {renderButtonOpenModal()}
      <Transition appear show={showModal} as={Fragment}>
        <Dialog
          as="div"
          className="HeroSearchFormMobile__Dialog relative z-max"
          onClose={closeModal}
        >
          <div className="fixed inset-0 bg-neutral-100 dark:bg-neutral-900">
            <div className="flex h-full">
              <Transition
                as={Fragment}
                enter="ease-out transition-transform"
                enterFrom="opacity-0 translate-y-52"
                enterTo="opacity-100 translate-y-0"
                leave="ease-in transition-transform"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-52"
              >
                <Dialog.Panel className="relative h-full overflow-scroll flex-1 flex flex-col justify-between ">
                  {showDialog && (
                    <Tab.Group manual>
                      <div className="absolute left-4 top-4">
                        <button className="" onClick={closeModal}>
                          <XMarkIcon className="w-5 h-5 text-black dark:text-white" />
                        </button>
                      </div>
                      <div className="flex-1 pt-7 px-1.5 sm:px-4 flex overflow-hidden">
                        <Tab.Panels className="flex-1 overflow-y-auto hiddenScrollbar py-4">
                          <Tab.Panel>
                            <div className="transition-opacity animate-[myblur_0.4s_ease-in-out]">
                              <CarsSearchForm
                                setShowModal={setShowModal}
                                setStartHours={setStartHours}
                                setEndHours={setEndHours}
                                endHours={endHours}
                                startHours={startHours}
                                setEndMinutes={setEndMinutes}
                                setStartMinutes={setStartMinutes}
                                endMinutes={endMinutes}
                                startMinutes={startMinutes}
                                setEndPeriod={setEndPeriod}
                                setStartPeriod={setStartPeriod}
                                endPeriod={endPeriod}
                                startPeriod={startPeriod}
                              />
                            </div>
                          </Tab.Panel>
                        </Tab.Panels>
                      </div>
                      <div className="px-4 py-3 bg-white dark:bg-neutral-900 border-t border-neutral-200 dark:border-neutral-700 flex justify-between">
                        {/* <button
                          type="button"
                          className="underline font-semibold flex-shrink-0"
                          onClick={() => {
                            setShowDialog(false);
                            resetIsShowingDialog();
                          }}
                        >
                          Clear all
                        </button> */}
                        <button
                          onClick={() => {
                            // Uncomment and adjust this logic if you are using lag time functionality
                            // if (isBeforeOrAfterLagTime() === false) {
                            //   toast.error(
                            //     `Unavailable within next ${companyData?.company?.meta?.booking_lag_time_value} ${companyData?.company?.meta?.booking_lag_time_interval}. Please select another time.`
                            //   );
                            //   return; // Return here to avoid executing further code
                            // }
                            if (!pickupLocation) {
                              toast.error("Please enter Pick up location");
                              closeModal();
                              return;
                            }
                            // Check if times are within operational hours
                            if (
                              !isWithinOperationalHours(
                                startHours,
                                startMinutes,
                                startPeriod,
                                endHours,
                                endMinutes,
                                endPeriod,
                                ourCompany
                              )
                            ) {
                              toast.error(
                                `Please select a pickup and drop-off time between our working hours of ${moment(
                                  ourCompany?.operational_start_time,
                                  "HH:mm:ss"
                                ).format("hh:mm A")} - ${moment(
                                  ourCompany?.operational_end_time,
                                  "HH:mm:ss"
                                ).format("hh:mm A")}`
                              );
                              closeModal();
                              return; // Prevent further execution
                            }

                            // Check for valid pickup location


                            // Validate start time
                            if (pickupLocation && !validateStartDateTime()) {
                              callAvailableFleetAPI(navigate);
                            }

                            // API call for available fleet and closing modal
                            Promise.all([callAvailableFleetAPI(navigate)]).then(
                              () => {
                                closeModal();
                              }
                            );
                          }}
                          className={`flex-shrink-0 px-4 py-2.5 cursor-pointer rounded-xl bg-primary-6000 flex items-center justify-center text-neutral-50 focus:outline-none relative z-20 w-full`}
                        >
                          {loadingAvailableFleet ? (
                            <svg
                              aria-hidden="true"
                              className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-400"
                              viewBox="0 0 100 101"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor"
                              />
                              <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill"
                              />
                            </svg>
                          ) : (
                            <>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={1.5}
                                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                />
                              </svg>
                              <span className="ml-2">Search</span>
                            </>
                          )}
                        </button>
                      </div>
                    </Tab.Group>
                  )}
                </Dialog.Panel>
              </Transition>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default HeroSearchForm2Mobile;
